import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { SortDirection } from '@e-origin/shared';

const c = initContract();

export const MeasureSolutionBody = z.object({
  hsCode: z.string().optional(),
  origin: z.string().optional(),
  measure: z.string().optional(),
  group: z.string().optional(),
  solution: z.string().optional(),
});

export type MeasureSolutionBody = z.infer<typeof MeasureSolutionBody>;

export const MeasureSolutionResponseItem = z.object({
  _id: z.any().optional(),
  hsCode: z.string().optional(),
  origin: z.string().optional(),
  measure: z.string().optional(),
  group: z.string().optional(),
  solution: z.string().optional(),
  createdAt: z.string().or(z.date()).optional(),
  updatedAt: z.string().or(z.date()).optional(),
});

export type MeasureSolutionResponseItem = z.infer<typeof MeasureSolutionResponseItem>;

export const MeasureSolutionCriteria = z.object({
  filters: z.object({ searchQuery: z.string().optional() }).optional(),
  pagination: z.object({ page: z.number().optional(), size: z.number().optional() }).optional(),
  sorting: z.object({ field: z.string().optional(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]).optional() }).optional(),
});

export type MeasureSolutionCriteria = z.infer<typeof MeasureSolutionCriteria>;

export const measureSolutionsContract = c.router({
  retrieveMeasureSolutions: {
    method: 'POST',
    path: '/measure-solutions',
    body: z.object({ criteria: MeasureSolutionCriteria.optional() }),
    responses: {
      200: z.object({
        data: z.object({
          measureSolutions: z.array(MeasureSolutionResponseItem),
          totalItems: z.number(),
        }),
      }),
    },
  },
  createMeasureSolution: {
    method: 'POST',
    path: '/measure-solutions/add',
    body: MeasureSolutionBody,
    responses: {
      201: z.object({ data: MeasureSolutionResponseItem }),
    },
  },
  editMeasureSolution: {
    method: 'POST',
    path: '/measure-solutions/edit/:id',
    pathParams: z.object({ id: z.string() }),
    body: MeasureSolutionBody,
    responses: {
      201: z.object({ data: MeasureSolutionResponseItem.nullable() }),
    },
  },
  deleteMeasureSolution: {
    method: 'DELETE',
    path: '/measure-solutions/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      204: c.noBody(),
    },
  },
});
